export const CATEGORY_META = {
  opportunities: { fr: "Opportunités", en: "Opportunities", icon: "Compass" },
  projects: { fr: "Projets", en: "Projects", icon: "LayoutGrid" },
  investment: { fr: "Investissement", en: "Investment", icon: "TrendingUp" },
  partners: { fr: "Partenaires", en: "Partners", icon: "Handshake" },
  sourcing: { fr: "Sourcing", en: "Sourcing", icon: "PackageSearch" },
  markets: { fr: "Marchés", en: "Markets", icon: "Globe" },
};

export const NAV_CATEGORIES = ["opportunities", "projects", "investment", "partners", "sourcing", "markets"];

export const INVESTMENT_OPERATIONS = [
  ["want_to_invest", "Je veux investir", "I want to invest"],
  ["seek_financing", "Je cherche un financement", "Seeking financing"],
  ["seek_investor", "Je cherche un investisseur", "Seeking an investor"],
  ["seek_coinvestor", "Je cherche un co-investisseur", "Seeking a co-investor"],
  ["seek_financial_associate", "Je cherche un associé financier", "Seeking a financial associate"],
  ["seek_operational_associate", "Je cherche un associé opérationnel", "Seeking an operational associate"],
  ["seek_expert_associate", "Je cherche un associé avec expertise", "Seeking an expert associate"],
  ["open_capital", "Je veux ouvrir mon capital", "Opening my capital"],
  ["seek_joint_venture", "Je cherche une joint-venture", "Seeking a joint venture"],
  ["seek_company_takeover", "Je cherche une entreprise à reprendre", "Seeking a company to take over"],
  ["seek_acquisition", "Je cherche une acquisition", "Seeking an acquisition"],
  ["cede_participation", "Je souhaite céder une participation", "Ceding a participation"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const INVESTMENT_ACTORS = [
  ["investor", "Investisseur", "Investor"], ["coinvestor", "Co-investisseur", "Co-investor"],
  ["shareholder", "Actionnaire", "Shareholder"], ["financial_associate", "Associé financier", "Financial associate"],
  ["operational_associate", "Associé opérationnel", "Operational associate"], ["expert_associate", "Associé expert", "Expert associate"],
  ["business_angel", "Business angel", "Business angel"], ["investment_fund", "Fonds d'investissement", "Investment fund"],
  ["financial_institution", "Institution financière", "Financial institution"], ["bank", "Banque", "Bank"],
  ["financing_partner", "Partenaire de financement", "Financing partner"], ["guarantee_body", "Organisme de garantie", "Guarantee body"],
  ["public_financier", "Financeur public", "Public financier"], ["private_financier", "Financeur privé", "Private financier"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const FINANCING_TYPES = [
  ["grant", "Subvention", "Grant"], ["loan", "Prêt", "Loan"], ["debt", "Dette", "Debt"],
  ["equity", "Equity", "Equity"], ["quasi_equity", "Quasi-equity", "Quasi-equity"],
  ["blended", "Financement mixte", "Blended finance"], ["guarantee", "Garantie", "Guarantee"],
  ["cofinancing", "Co-financement", "Co-financing"], ["direct_investment", "Investissement direct", "Direct investment"],
  ["joint_venture", "Joint-venture", "Joint venture"], ["other", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const OPP_TYPES = [
  ["financement", "Financement", "Financing"], ["investissement", "Investissement", "Investment"],
  ["appel_a_projets", "Appel à projets", "Call for projects"], ["programme_appui", "Programme d'appui", "Support program"],
  ["garantie", "Garantie", "Guarantee"], ["financement_mixte", "Financement mixte", "Blended finance"],
  ["pret", "Prêt", "Loan"], ["equity", "Equity", "Equity"], ["subvention", "Subvention", "Grant"],
  ["partenariat", "Partenariat", "Partnership"], ["contrat", "Contrat", "Contract"],
  ["distribution", "Distribution", "Distribution"], ["representation", "Représentation", "Representation"],
  ["acquisition", "Acquisition", "Acquisition"], ["joint_venture", "Joint-venture", "Joint venture"],
  ["autre", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const PARTNER_TYPES = [
  ["distributor", "Distributeur", "Distributor"],
  ["representative", "Représentant", "Representative"],
  ["commercial_agent", "Agent commercial", "Commercial agent"],
  ["manufacturer", "Fabricant", "Manufacturer"],
  ["supplier", "Fournisseur", "Supplier"],
  ["producer", "Producteur", "Producer"],
  ["industrial_partner", "Partenaire industriel", "Industrial partner"],
  ["technology_partner", "Partenaire technologique", "Technology partner"],
  ["logistics_partner", "Partenaire logistique", "Logistics partner"],
  ["commercial_partner", "Partenaire commercial", "Commercial partner"],
  ["service_provider", "Prestataire", "Service provider"],
  ["local_operator", "Opérateur local", "Local operator"],
  ["other", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const EXPERT_CATEGORIES = [
  ["agriculture", "Agriculture", "Agriculture"],
  ["agro_industry", "Agro-industrie", "Agri-business"],
  ["industry", "Industrie", "Industry"],
  ["technology", "Technologie", "Technology"],
  ["finance", "Finance", "Finance"],
  ["commerce", "Commerce", "Trade"],
  ["energy", "Énergie", "Energy"],
  ["logistics", "Logistique", "Logistics"],
  ["real_estate", "Immobilier", "Real estate"],
  ["tourism", "Tourisme", "Tourism"],
  ["import_export", "Export / Import", "Export / Import"],
  ["market_entry", "Implantation", "Market entry"],
  ["business_development", "Business development", "Business development"],
  ["project_structuring", "Structuration de projets", "Project structuring"],
  ["financing", "Financement", "Financing"],
  ["legal", "Juridique", "Legal"],
  ["tax", "Fiscalité", "Tax"],
  ["regulation", "Réglementation", "Regulation"],
  ["marketing", "Marketing", "Marketing"],
  ["industrial_transformation", "Transformation industrielle", "Industrial transformation"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const SOURCING_DIRECTIONS = [
  { value: "buy", fr: "Je cherche à acheter", en: "I want to buy" },
  { value: "sell", fr: "Je cherche à vendre", en: "I want to sell" },
];

export const SOURCING_BUY_TYPES = [
  ["product", "Produit", "Product"],
  ["raw_material", "Matière première", "Raw material"],
  ["producer", "Producteur", "Producer"],
  ["supplier", "Fournisseur", "Supplier"],
  ["manufacturer", "Fabricant", "Manufacturer"],
  ["equipment", "Équipement", "Equipment"],
  ["technology", "Technologie", "Technology"],
  ["production_capacity", "Capacité de production", "Production capacity"],
  ["service", "Service", "Service"],
  ["other", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const SOURCING_SELL_TYPES = [
  ["product", "Produit", "Product"],
  ["raw_material", "Matière première", "Raw material"],
  ["production", "Production", "Production"],
  ["industrial_capacity", "Capacité industrielle", "Industrial capacity"],
  ["technology", "Technologie", "Technology"],
  ["equipment", "Équipement", "Equipment"],
  ["service", "Service", "Service"],
  ["other", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const SOURCING_ALL_TYPES = [
  ...SOURCING_BUY_TYPES,
  { value: "production", fr: "Production", en: "Production" },
  { value: "industrial_capacity", fr: "Capacité industrielle", en: "Industrial capacity" },
];

export const TRANSFORMATION_LEVELS = [
  ["raw", "Brut / non transformé", "Raw / unprocessed"],
  ["semi_processed", "Semi-transformé", "Semi-processed"],
  ["processed", "Transformé", "Processed"],
  ["finished", "Produit fini", "Finished product"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const MARKET_ZONES = [
  ["africa", "Afrique", "Africa"],
  ["europe", "Europe", "Europe"],
  ["china", "Chine", "China"],
  ["india", "Inde", "India"],
  ["other", "Autres marchés", "Other markets"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const COVERAGE_LEVELS = [
  { value: "covered", fr: "Couvert", en: "Covered", descFr: "RSTI dispose d'une couverture active et de contacts vérifiés.", descEn: "RSTI has active coverage and verified contacts." },
  { value: "developing", fr: "En développement", en: "Developing", descFr: "Couverture en cours de structuration.", descEn: "Coverage being structured." },
  { value: "on_demand", fr: "Sur demande", en: "On request", descFr: "RSTI active la recherche à la demande.", descEn: "RSTI activates the search on request." },
];

export const MARKET_INTEL_CATEGORIES = [
  ["business_environment", "Environnement commercial", "Business environment"],
  ["market_access", "Accès marché", "Market access"],
  ["regulation", "Réglementation", "Regulation"],
  ["needs", "Besoins", "Needs"],
  ["products_sought", "Produits recherchés", "Products sought"],
  ["production_capacities", "Capacités de production", "Production capacities"],
  ["trends", "Tendances", "Trends"],
  ["opportunities", "Opportunités", "Opportunities"],
  ["constraints", "Contraintes", "Constraints"],
  ["competition", "Concurrence", "Competition"],
  ["costs", "Coûts / conditions", "Costs / conditions"],
  ["sourcing", "Sourcing", "Sourcing"],
  ["distribution", "Distribution", "Distribution"],
  ["market_entry", "Implantation", "Market entry"],
  ["import_export", "Export / Import", "Export / Import"],
  ["other", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const SEARCH_GROUPS = [
  { key: "markets", fr: "Marchés", en: "Markets", path: "/marches", slugField: "slug", titleField: "country_name" },
  { key: "opportunities", fr: "Opportunités", en: "Opportunities", path: "/opportunites", slugField: "slug", titleField: "title" },
  { key: "projects", fr: "Projets", en: "Projects", path: "/projets", slugField: "slug", titleField: "title" },
  { key: "investments", fr: "Investissement", en: "Investment", path: "/investissement", slugField: "slug", titleField: "title" },
  { key: "partners", fr: "Partenaires", en: "Partners", path: "/partenaires", slugField: "slug", titleField: "organization" },
  { key: "experts", fr: "Experts", en: "Experts", path: "/experts", slugField: "slug", titleField: "name" },
  { key: "sourcing", fr: "Sourcing", en: "Sourcing", path: "/sourcing", slugField: "slug", titleField: "title" },
  { key: "insights", fr: "Analyses", en: "Insights", path: "/insights", slugField: "slug", titleField: "title" },
];

export const MARKET_TEST_TYPES = [
  ["product", "Test produit", "Product test"],
  ["commercial", "Test commercial", "Commercial test"],
  ["market", "Test marché", "Market test"],
  ["price", "Test prix", "Price test"],
  ["distribution", "Test distribution", "Distribution test"],
  ["demand", "Test demande", "Demand test"],
  ["partner", "Test partenaire", "Partner test"],
  ["other", "Autre", "Other"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const MARKET_TEST_STATUS_META = {
  submitted: { fr: "Soumission", en: "Submitted" },
  pending: { fr: "En attente", en: "Pending" },
  qualification: { fr: "Qualification RSTI", en: "RSTI qualification" },
  test_prep: { fr: "Test en préparation", en: "Test in preparation" },
  testing: { fr: "Test en cours", en: "Testing" },
  analysis: { fr: "Analyse", en: "Analysis" },
  decision: { fr: "Décision", en: "Decision" },
  done: { fr: "Terminé", en: "Done" },
  archived: { fr: "Archivé", en: "Archived" },
};

export const MARKET_TEST_DECISIONS = [
  { value: "go", fr: "GO", en: "GO", cls: "border-green-600/30 bg-green-50 text-green-700" },
  { value: "adapt", fr: "ADAPT", en: "ADAPT", cls: "border-amber-600/30 bg-amber-50 text-amber-700" },
  { value: "stop", fr: "STOP", en: "STOP", cls: "border-red-600/30 bg-red-50 text-red-700" },
];

export const MODULE_STATUS_META = {
  draft: { fr: "Brouillon", en: "Draft" },
  verifying: { fr: "En vérification", en: "Verifying" },
  published: { fr: "Publié", en: "Published" },
  updated: { fr: "Mis à jour", en: "Updated" },
  suspended: { fr: "Suspendu", en: "Suspended" },
  archived: { fr: "Archivé", en: "Archived" },
};

export const OPP_STATUS_META = {
  draft: { fr: "Brouillon", en: "Draft", cls: "border-tertiary bg-sand text-anthracite/60" },
  verifying: { fr: "En vérification", en: "Verifying", cls: "border-blue-200 bg-blue-50 text-blue-700" },
  published: { fr: "Publiée", en: "Published", cls: "border-green-200 bg-green-50 text-green-700" },
  updated: { fr: "Mise à jour", en: "Updated", cls: "border-green-200 bg-green-50 text-green-700" },
  expired: { fr: "Expirée", en: "Expired", cls: "border-orange-200 bg-orange-50 text-orange-700" },
  archived: { fr: "Archivée", en: "Archived", cls: "border-tertiary bg-tertiary/40 text-anthracite/50" },
};

export const PROJECT_TYPES = [
  ["search_financing", "Recherche de financement", "Seeking financing"],
  ["search_investor", "Recherche d'investisseur", "Seeking investor"],
  ["search_associate", "Recherche d'associé", "Seeking associate"],
  ["search_partner", "Recherche de partenaire", "Seeking partner"],
  ["search_distributor", "Recherche de distributeur", "Seeking distributor"],
  ["search_supplier", "Recherche de fournisseur", "Seeking supplier"],
  ["search_manufacturer", "Recherche de fabricant", "Seeking manufacturer"],
  ["project_to_develop", "Projet à développer", "Project to develop"],
  ["project_to_takeover", "Projet à reprendre", "Project to take over"],
  ["joint_venture", "Joint-venture", "Joint venture"],
  ["capital_opening", "Ouverture de capital", "Capital opening"],
  ["associate_financial", "Associé financier", "Financial associate"],
  ["associate_operational", "Associé opérationnel", "Operational associate"],
  ["associate_expertise", "Associé avec expertise", "Expertise associate"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const PROJECT_STATUS_META = {
  draft: { fr: "Brouillon", en: "Draft", cls: "border-tertiary bg-sand text-anthracite/60" },
  evaluating: { fr: "En évaluation", en: "Evaluating", cls: "border-blue-200 bg-blue-50 text-blue-700" },
  active: { fr: "Actif", en: "Active", cls: "border-green-200 bg-green-50 text-green-700" },
  in_progress: { fr: "En cours", en: "In progress", cls: "border-green-200 bg-green-50 text-green-700" },
  suspended: { fr: "Suspendu", en: "Suspended", cls: "border-orange-200 bg-orange-50 text-orange-700" },
  completed: { fr: "Terminé", en: "Completed", cls: "border-tertiary bg-sand text-anthracite/60" },
  archived: { fr: "Archivé", en: "Archived", cls: "border-tertiary bg-tertiary/40 text-anthracite/50" },
};

export const PROJECT_STAGES = [
  ["idea", "Idée", "Idea"], ["early", "Amorçage", "Early"], ["development", "Développement", "Development"],
  ["growth", "Croissance", "Growth"], ["established", "Établi", "Established"],
].map(([value, fr, en]) => ({ value, fr, en }));

export const SUBMISSION_TYPES = [
  { value: "offer", fr: "Offre", en: "Offer" },
  { value: "need", fr: "Besoin", en: "Need" },
  { value: "search", fr: "Recherche", en: "Search" },
  { value: "capacity", fr: "Capacité", en: "Capacity" },
  { value: "project", fr: "Projet", en: "Project" },
  { value: "partner_search", fr: "Recherche de partenaire", en: "Partner search" },
  { value: "investor_search", fr: "Recherche d'investisseur", en: "Investor search" },
  { value: "supplier_search", fr: "Recherche de fournisseur", en: "Supplier search" },
  { value: "client_search", fr: "Recherche de client", en: "Client search" },
  { value: "distributor_search", fr: "Recherche de distributeur", en: "Distributor search" },
  { value: "manufacturer_search", fr: "Recherche de fabricant", en: "Manufacturer search" },
  { value: "associate_search", fr: "Recherche d'associé", en: "Associate search" },
  { value: "partner_profile", fr: "Profil partenaire", en: "Partner profile" },
  { value: "sourcing_buy", fr: "Sourcing — je cherche à acheter", en: "Sourcing — I want to buy" },
  { value: "sourcing_sell", fr: "Sourcing — je cherche à vendre", en: "Sourcing — I want to sell" },
];

export const SUBMISSION_STATUS_META = {
  pending: { fr: "En attente de validation", en: "Pending validation", cls: "border-tertiary bg-sand text-anthracite/60" },
  in_review: { fr: "En cours d'examen", en: "In review", cls: "border-blue-200 bg-blue-50 text-blue-700" },
  info_requested: { fr: "Informations demandées", en: "Info requested", cls: "border-amber-200 bg-amber-50 text-amber-700" },
  approved: { fr: "Validée", en: "Approved", cls: "border-green-200 bg-green-50 text-green-700" },
  rejected: { fr: "Refusée", en: "Rejected", cls: "border-red-200 bg-red-50 text-red-600" },
  suspended: { fr: "Suspendue", en: "Suspended", cls: "border-orange-200 bg-orange-50 text-orange-700" },
  archived: { fr: "Archivée", en: "Archivée", cls: "border-tertiary bg-tertiary/40 text-anthracite/50" },
};

export const PROFILE_TYPES = [
  { value: "project_holder", fr: "Porteur de projet", en: "Project holder" },
  { value: "investor", fr: "Investisseur", en: "Investor" },
  { value: "company", fr: "Entreprise", en: "Company" },
  { value: "partner", fr: "Partenaire", en: "Partner" },
  { value: "supplier", fr: "Fournisseur", en: "Supplier" },
  { value: "distributor", fr: "Distributeur", en: "Distributor" },
  { value: "manufacturer", fr: "Fabricant", en: "Manufacturer" },
  { value: "expert", fr: "Expert", en: "Expert" },
  { value: "institution", fr: "Institution", en: "Institution" },
  { value: "other", fr: "Autre", en: "Other" },
];

export const translations = {
  fr: {
    nav_connect: "RSTI Connect",
    nav_insights: "Analyses",
    nav_about: "À propos",
    cta_connect: "Nous solliciter",
    cta_explore: "Explorer",
    cta_learn_more: "En savoir plus",
    cta_view_detail: "Voir le détail",
    search_button: "Rechercher",
    search_examples: "Exemples",
    verified: "RSTI Verified",
    verification: "Vérification",
    verification_level: "Niveau de vérification",
    last_verified: "Dernière vérification",
    source: "Source",
    no_results: "Aucun résultat pour votre recherche.",
    results_for: "Résultats pour",
    all: "Tout",
    sector: "Secteur",
    country: "Pays",
    region: "Région",
    intent: "Intention",
    intent_offer: "Propose",
    intent_seek: "Recherche",
    intent_both: "Les deux",
    ambition_title: "Notre ambition",
    process_title: "Notre méthode",
    experts_title: "L'expertise humaine",
    experts_sub: "La technologie facilite la connexion. L'expertise fait la différence.",
    insights_title: "Analyses & perspectives",
    featured_title: "Sélection vérifiée",
    featured_sub: "Opportunités, projets et partenaires structurés par RSTI.",
    explore_categories: "Explorer par intention",
    connect_title: "Confiez-nous votre besoin",
    connect_sub: "Décrivez votre besoin. RSTI identifie, vérifie, structure et connecte.",
    form_name: "Nom complet",
    form_email: "Email",
    form_company: "Entreprise",
    form_phone: "Téléphone",
    form_intent: "Votre intention",
    form_category: "Domaine",
    form_message: "Votre besoin",
    form_submit: "Envoyer ma demande",
    form_success: "Demande envoyée. L'équipe RSTI vous recontactera.",
    form_choose: "Sélectionner",
    footer_tagline: "Reveal · Structure · Transformer · Impact",
    footer_rights: "Tous droits réservés.",
    admin_login: "Espace administrateur",
    member_login: "Connexion",
    member_signup: "Créer un compte",
    member_space: "Mon espace",
    logout: "Déconnexion",
    account_title: "Mon espace membre",
    account_profile: "Mon profil RSTI Connect",
    account_completeness: "Profil complété",
    account_type: "Type de profil",
    account_org: "Organisation",
    account_sectors: "Secteurs",
    account_markets: "Pays / marchés",
    account_intents: "Intentions",
    account_needs: "Vos besoins",
    account_offers: "Vos offres",
    account_keywords: "Mots-clés",
    account_save: "Enregistrer mon profil",
    account_saved: "Profil enregistré",
    account_matches: "Correspondances (aperçu)",
    account_matches_soon: "Suggestions générées automatiquement à partir de votre profil — ce ne sont pas des garanties. L'équipe RSTI reste au centre de la qualification et de la mise en relation.",
    signup_title: "Rejoindre RSTI Global",
    signup_sub: "Créez votre espace pour être identifié, vérifié et connecté.",
    signup_success: "Compte créé. Consultez votre email pour activer votre espace.",
    signup_resend: "Renvoyer l'email de vérification",
    login_title: "Connexion à votre espace",
    login_need_verify: "Votre email n'est pas encore vérifié.",
    verify_progress: "Vérification en cours…",
    verify_success: "Email vérifié. Bienvenue !",
    verify_error: "Lien invalide ou expiré.",
    verification_levels: {
      unverified: "Non vérifié",
      declared: "Déclaré",
      verified: "Vérifié",
      premium: "Premium vérifié",
    },
  },
  en: {
    nav_connect: "RSTI Connect",
    nav_insights: "Insights",
    nav_about: "About",
    cta_connect: "Contact us",
    cta_explore: "Explore",
    cta_learn_more: "Learn more",
    cta_view_detail: "View details",
    search_button: "Search",
    search_examples: "Examples",
    verified: "RSTI Verified",
    verification: "Verification",
    verification_level: "Verification level",
    last_verified: "Last verified",
    source: "Source",
    no_results: "No results for your search.",
    results_for: "Results for",
    all: "All",
    sector: "Sector",
    country: "Country",
    region: "Region",
    intent: "Intent",
    intent_offer: "Offers",
    intent_seek: "Seeks",
    intent_both: "Both",
    ambition_title: "Our ambition",
    process_title: "Our method",
    experts_title: "Human expertise",
    experts_sub: "Technology enables the connection. Expertise makes the difference.",
    insights_title: "Insights & perspectives",
    featured_title: "Verified selection",
    featured_sub: "Opportunities, projects and partners structured by RSTI.",
    explore_categories: "Explore by intent",
    connect_title: "Entrust us with your need",
    connect_sub: "Describe your need. RSTI identifies, verifies, structures and connects.",
    form_name: "Full name",
    form_email: "Email",
    form_company: "Company",
    form_phone: "Phone",
    form_intent: "Your intent",
    form_category: "Domain",
    form_message: "Your need",
    form_submit: "Send my request",
    form_success: "Request sent. The RSTI team will get back to you.",
    form_choose: "Select",
    footer_tagline: "Reveal · Structure · Transformer · Impact",
    footer_rights: "All rights reserved.",
    admin_login: "Admin area",
    member_login: "Sign in",
    member_signup: "Create account",
    member_space: "My space",
    logout: "Sign out",
    account_title: "My member area",
    account_profile: "My RSTI Connect profile",
    account_completeness: "Profile completed",
    account_type: "Profile type",
    account_org: "Organization",
    account_sectors: "Sectors",
    account_markets: "Countries / markets",
    account_intents: "Intents",
    account_needs: "Your needs",
    account_offers: "Your offers",
    account_keywords: "Keywords",
    account_save: "Save my profile",
    account_saved: "Profile saved",
    account_matches: "Matches (preview)",
    account_matches_soon: "Suggestions generated automatically from your profile — these are not guarantees. The RSTI team stays at the center of qualification and connection.",
    signup_title: "Join RSTI Global",
    signup_sub: "Create your space to be identified, verified and connected.",
    signup_success: "Account created. Check your email to activate your space.",
    signup_resend: "Resend verification email",
    login_title: "Sign in to your space",
    login_need_verify: "Your email is not verified yet.",
    verify_progress: "Verifying…",
    verify_success: "Email verified. Welcome!",
    verify_error: "Invalid or expired link.",
    verification_levels: {
      unverified: "Unverified",
      declared: "Declared",
      verified: "Verified",
      premium: "Premium verified",
    },
  },
};
